import axios from 'axios';

// var webRoot = 'http://zlbb.qzhip.test/index.php';
var webRoot = 'https://zlbb.qzhip.com/index.php';

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: webRoot + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url: webRoot + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
             token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

// 通用拦截响应response，并做一些错误处理


export {
    loginreq,
    req
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js